"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    padding: ", "px ", "px;\n    color: ", ";\n    font-weight: 600;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: ", "px ", "px;\n    color: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    font-size: ", "px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var Wrapper = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return styled_components_1.css(_templateObject2(), theme.spacing.unit * 2);
});
var Label = styled_components_1["default"].span(_templateObject3(), function (_ref2) {
  var theme = _ref2.theme;
  return styled_components_1.css(_templateObject4(), theme.spacing.unit, theme.spacing.unit * 2, theme.palette.text.secondary);
});
var Value = styled_components_1["default"].span(_templateObject5(), function (_ref3) {
  var theme = _ref3.theme;
  return styled_components_1.css(_templateObject6(), theme.spacing.unit, theme.spacing.unit * 2, theme.palette.text["default"]);
});
/**
 * Stat Table Component
 *
 * Component for displaying quick stats
 *
 */

var StatTable = function StatTable(_a) {
  var _a$data = _a.data,
      data = _a$data === void 0 ? [] : _a$data,
      rest = __rest(_a, ["data"]);

  return react_1["default"].createElement(Wrapper, Object.assign({}, rest), data.map(function (_ref4) {
    var label = _ref4.label,
        value = _ref4.value;
    return [react_1["default"].createElement(Label, {
      className: 'st-label'
    }, label), react_1["default"].createElement(Value, {
      className: 'st-value'
    }, value)];
  }));
};

exports["default"] = StatTable;